import {
  SPOR_TOTO_PLAY_REQUEST,
  SPOR_TOTO_PLAY_SUCCESS,
  SPOR_TOTO_PLAY_FAILURE,
  SPOR_TOTO_GET_EVENTS_REQUEST,
  SPOR_TOTO_GET_EVENTS_SUCCESS,
  SPOR_TOTO_GET_EVENTS_FAILURE,
  SPOR_TOTO_GET_PLAY_RATIO_LIST_REQUEST,
  SPOR_TOTO_GET_PLAY_RATIO_LIST_SUCCESS,
  SPOR_TOTO_GET_PLAY_RATIO_LIST_FAILURE,
  SPOR_TOTO_RESULT_REQUEST,
  SPOR_TOTO_RESULT_SUCCESS,
  SPOR_TOTO_RESULT_FAILURE,
  SPOR_TOTO_RESULT_BY_WEEKLY_REQUEST,
  SPOR_TOTO_RESULT_BY_WEEKLY_SUCCESS,
  SPOR_TOTO_RESULT_BY_WEEKLY_FAILURE,
  SPOR_TOTO_COUPONS_REQUEST,
  SPOR_TOTO_COUPONS_SUCCESS,
  SPOR_TOTO_COUPONS_RESET,
  SPOR_TOTO_COUPONS_FAILURE,
  SPOR_TOTO_CANCEL_COUPON_REQUEST,
  SPOR_TOTO_CANCEL_COUPON_SUCCESS,
  SPOR_TOTO_CANCEL_COUPON_FAILURE,
  SPOR_TOTO_COUPON_EARNINGS_REQUEST,
  SPOR_TOTO_COUPON_EARNINGS_SUCCESS,
  SPOR_TOTO_COUPON_EARNINGS_FAILURE,
  SPOR_TOTO_SAVE_REQUEST,
  SPOR_TOTO_SAVE_SUCCESS,
  SPOR_TOTO_SAVE_FAILURE,
  GET_SPOR_TOTO_HISTORY_LIST_REQUEST,
  GET_SPOR_TOTO_HISTORY_LIST_SUCCESS,
  GET_SPOR_TOTO_HISTORY_LIST_FAILURE,
  SPOR_TOTO_DELETE_SAVED_COUPON_REQUEST,
  SPOR_TOTO_DELETE_SAVED_COUPON_SUCCESS,
  SPOR_TOTO_DELETE_SAVED_COUPON_FAILURE,

  SPOR_TOTO_UPDATE_SAVED_COUPON_REQUEST,
  SPOR_TOTO_UPDATE_SAVED_COUPON_SUCCESS,
  SPOR_TOTO_UPDATE_SAVED_COUPON_FAILURE

} from 'Store/constants';

const initialState = {
  couponsData: {
    coupons: {
      list: [],
      offset: 0,
      totalElements: 0,
      totalPages: 0 },
    isLoading: false,
    error: null
  },
  eventsData: {
    events: {},
    isLoading: false,
    error: null
  },
  playRatioData: {
    list: [],
    isLoading: false,
    error: null
  },
  playData: {
    response: {},
    isLoading: false,
    error: null
  },
  resultData: {
    result: {},
    isLoading: null,
    error: null
  },
  cancelCoupon: {
    data: {},
    isLoading: false,
    error: null
  },
  couponEarnings: {
    data: {},
    isLoading: null,
    error: null
  },
  deleteSavedCoupon: {
    data: {},
    isLoading: false,
    error: null
  },
  updateSavedCoupon: {
    data: {},
    isLoading: false,
    error: null
  }

};

export default (state = initialState, action) => {
  switch (action.type) {
    case SPOR_TOTO_COUPON_EARNINGS_REQUEST:
      return { ...state, couponEarnings: { data: {}, isLoading: true, error: null } };
    case SPOR_TOTO_COUPON_EARNINGS_SUCCESS:
      return { ...state,
        couponEarnings: {
          data: action.payload,
          isLoading: false,
          error: null
        }
      };
    case SPOR_TOTO_COUPON_EARNINGS_FAILURE:
      return { ...state, couponEarnings: { data: {}, isLoading: false, error: action.payload } };
    case SPOR_TOTO_COUPONS_RESET:
      return { ...state, couponsData: { coupons: {}, isLoading: true, error: null } };
    case SPOR_TOTO_COUPONS_REQUEST:
      return { ...state, couponsData: { coupons: { ...state?.couponsData?.coupons ?? {} }, isLoading: true, error: null } };
    case SPOR_TOTO_COUPONS_SUCCESS:
      return { ...state,
        couponsData: {
          isLoading: false,
          error: null,
          coupons: state.couponsData.coupons.list ?  {
            ...action.payload,
            list: [...state.couponsData.coupons.list, ...action.payload.list]
          } : action.payload
        }
      };
    case SPOR_TOTO_COUPONS_FAILURE:
      return { ...state, couponsData: { coupons: {}, isLoading: false, error: action.payload } };

    case SPOR_TOTO_RESULT_REQUEST:
      return { ...state, resultData: { result: {}, isLoading: true, error: null } };
    case SPOR_TOTO_RESULT_SUCCESS:
      return {
        ...state,
        resultData: {
          result: action.payload,
          isLoading: false,
          error: null
        }
      };
    case SPOR_TOTO_RESULT_FAILURE:
      return { ...state, resultData: { result: {}, isLoading: false, error: action.payload } };

    case SPOR_TOTO_PLAY_REQUEST:
      return { ...state, playData: { playData: {}, isLoading: true, error: null } };
    case SPOR_TOTO_PLAY_SUCCESS:
      return { ...state, playData: { ...action.payload, isLoading: false, error: null } };
    case SPOR_TOTO_PLAY_FAILURE:
      return { ...state, playData: { playData: {}, isLoading: false, error: action.payload } };

    case SPOR_TOTO_SAVE_REQUEST:
      return { ...state, playData: { playData: {}, isLoading: true, error: null } };
    case SPOR_TOTO_SAVE_SUCCESS:
      return { ...state, playData: { ...action.payload, isLoading: false, error: null } };
    case SPOR_TOTO_SAVE_FAILURE:
      return { ...state, playData: { playData: {}, isLoading: false, error: action.payload } };

    case SPOR_TOTO_GET_EVENTS_REQUEST:
      return { ...state, eventsData: { events: {}, isLoading: true, error: null } };
    case SPOR_TOTO_GET_EVENTS_SUCCESS:
      return {
        ...state,
        eventsData: {
          events: action.payload,
          isLoading: false,
          error: null
        }
      };
    case SPOR_TOTO_GET_EVENTS_FAILURE:
      return { ...state, eventsData: { events: {}, isLoading: false, error: action.payload } };
    
    case SPOR_TOTO_GET_PLAY_RATIO_LIST_REQUEST:
      return { ...state, playRatioData: { list: [], isLoading: true, error: null } };
    case SPOR_TOTO_GET_PLAY_RATIO_LIST_SUCCESS:
      return { ...state, playRatioData: { list: [...action.payload.playRatioList], isLoading: false, error: null } };
    case SPOR_TOTO_GET_PLAY_RATIO_LIST_FAILURE:
      return { ...state, playRatioData: { list: [], isLoading: false, error: action.payload } };

    case SPOR_TOTO_CANCEL_COUPON_REQUEST:
      return { ...state, cancelCoupon: { data: {}, isLoading: true, error: null } };
    case SPOR_TOTO_CANCEL_COUPON_SUCCESS:
      return { ...state, cancelCoupon: { data: action.payload, isLoading: false, error: null } };
    case SPOR_TOTO_CANCEL_COUPON_FAILURE:
      return { ...state, cancelCoupon: { data: {}, isLoading: false, error: action.payload } };

    case GET_SPOR_TOTO_HISTORY_LIST_REQUEST:
      return { ...state,
        isLoading: true,
        isFetched: false,
        error: null
      };
    case GET_SPOR_TOTO_HISTORY_LIST_SUCCESS:
      return {  ...state,
        data: action.payload,
        isFetched: true,
        isLoading: false,
        error: null };
    case GET_SPOR_TOTO_HISTORY_LIST_FAILURE:
      return {
        ...state,
        isFetched: true,
        isLoading: false,
        error: action.payload
      };

    case SPOR_TOTO_RESULT_BY_WEEKLY_REQUEST:
      return { ...state, resultData: { result: {}, isLoading: true, error: null } };
    case SPOR_TOTO_RESULT_BY_WEEKLY_SUCCESS:
      return {
        ...state,
        resultData: {
          result: action.payload,
          isLoading: false,
          error: null
        }
      };
    case SPOR_TOTO_RESULT_BY_WEEKLY_FAILURE:
      return { ...state, resultData: { result: {}, isLoading: false, error: action.payload } };
      
    case SPOR_TOTO_DELETE_SAVED_COUPON_REQUEST:
      return {
        ...state,
        deleteSavedCoupon: { data: {}, isLoading: true, error: null }
      };
    case SPOR_TOTO_DELETE_SAVED_COUPON_SUCCESS:
      return {
        ...state,
        deleteSavedCoupon: { data: action.payload, isLoading: false, error: null }
      };
    case SPOR_TOTO_DELETE_SAVED_COUPON_FAILURE:
      return {
        ...state,
        deleteSavedCoupon: { data: {}, isLoading: false, error: action.payload }
      };
    

    case SPOR_TOTO_UPDATE_SAVED_COUPON_REQUEST:
      return {
        ...state,
        updateSavedCoupon: { data: {}, isLoading: true, error: null }
      };
    case SPOR_TOTO_UPDATE_SAVED_COUPON_SUCCESS:
      return {
        ...state,
        updateSavedCoupon: { data: action.payload, isLoading: false, error: null }
      };
    case SPOR_TOTO_UPDATE_SAVED_COUPON_FAILURE:
      return {
        ...state,
        updateSavedCoupon: { data: {}, isLoading: false, error: action.payload }
      };
    default:
      return state;
  }
};
